import DotProgress from './DotProgress';

export default DotProgress;
